export const countryStateReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_COUNTRY_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        chats: null,
      };
    }
    case "GET_COUNTRY_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        chats: action.payload,
      };
    }
    case "GET_COUNTRY_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        chats: action.payload,
      };
    }

    case "GET_COUNTRY_REQUEST": {
      return {
        ...state,
        loading: true,
        individualChat: null,
      };
    }
    case "GET_COUNTRY_SUCCESS": {
      return {
        ...state,
        loading: false,
        individualChat: action.payload,
      };
    }
    case "GET_COUNTRY_FAILED": {
      return {
        ...state,
        loading: false,
        individualChat: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};